
const newModel = () => {
    return {
        danTocId: null,
        danSo: null,
        tenKhac: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        nhomDanTocId: null,
        tenNhomDanToc: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        danTocId: null,
        danSo: null,
        tenKhac: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        nhomDanTocId: null,
        enabled: null,
    }
}

const fromJson = (item) => {
    return {
        danTocId: item.danTocId,
        danSo: item.danSo,
        tenKhac: item.tenKhac,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        nhomDanTocId: item.nhomDanTocId,
        tenNhomDanToc: item.tenNhomDanToc,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        danTocId: item.danTocId,
        danSo: item.danSo,
        tenKhac: item.tenKhac,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        nhomDanTocId: item.nhomDanTocId,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        loaiDiadiemId: null,
        ten: null,
        nhomDanTocId: null,
        enabled: null,
    }

}

const errors = () => {
    return {
        danTocId: null,
        danSo: null,
        tenKhac: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        nhomDanTocId: null,
        enabled: null,
    }
}

export const danTocModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    fromJson,
    errors,
}


